import React from 'react';
import classNames from 'classnames';
import Chart from '@/business-components/chart';
import DataCard from '@/business-components/dataCard';
// import CustomEmpty from '@/business-components/CustomEmpty';
// import Tooltip from '@/components/tooltip';

import CustomEmpty from '@/business-components/CustomEmpty';
import Dot from '@/components/Dot';
import { formatNumberValueToChineseUnit } from '@/utils/format';
import styles from './index.module.scss';

export default function FinancingEnv({ data }) {
  const isEmpty = arr => {
    return arr.every(item => !item);
  };
  //金额转换
  // const formatAmount = useCallback(price => {
  //   if (!isNaN(+price)) {
  //     return formatNumberValueToChineseUnit(+price * 1e4, 2);
  //   }
  // }, []);
  return (
    <Chart
      title={
        <span className={styles.title}>
          融资情况
          {/*<Tooltip title="主要评估行业以及品牌的融资情况，反映市场对该品牌的投资热情" placement="right" />*/}
        </span>
      }
      panelClassName={styles.potentialChart}
    >
      <div className={classNames('flex-row-nowrap', 'flex-start-center', styles.potential)}>
        {data?.map((item, index) => (
          <>
            {isEmpty([
              item?.totalFinanceNum,
              item?.financeNum,
              item?.totalFinanceAmount,
              item?.financeAmountNum,
              item?.lastFinanceRoundsName,
            ]) ? (
              <div className={styles.cardItem}>
                <div className={classNames('flex-row-nowrap', 'flex-start-center')}>
                  <Dot style={{ marginRight: '4px' }} />
                  {item?.chName}
                </div>
                <CustomEmpty />
              </div>
            ) : (
              <DataCard
                key={index}
                brandName={item?.chName}
                indicatorData={[
                  { indicatorName: '母公司累计融资次数', indicatorNum: item?.totalFinanceNum },
                  // { indicatorName: '融资总次数', indicatorNum: item?.financeNum },
                  {
                    indicatorName: '母公司累计融资金额',
                    indicatorNum: formatNumberValueToChineseUnit(item?.totalFinanceAmount, 2)?.value,
                    indicatorUnit: formatNumberValueToChineseUnit(item?.totalFinanceAmount, 2)?.unit,
                  },
                  // {
                  //   indicatorName: '融资总金额',
                  //   indicatorNum: formatAmount(item?.financeAmountNum)?.value,
                  //   indicatorUnit: formatAmount(item?.financeAmountNum)?.unit,
                  // },
                  { indicatorName: '母公司融资轮次', indicatorNum: item?.lastFinanceRoundsName },
                ]}
                className={styles.cardItem}
              />
            )}
          </>
        ))}
      </div>
    </Chart>
  );
}
